import {
  useInfiniteQuery,
  useQuery,
  UseQueryOptions,
  useQueryClient,
  useMutation,
} from 'react-query'
import { PaymentMethodsApi } from '@trybeapp/sdk.customer'
import {
  ListPaymentMethods,
  ListPaymentMethodsRequest,
  PaymentMethodsApi as PaymentMethodsApiTs,
} from '@trybeapp/sdk'
import { apiConfiguration } from 'utilities/TrybeApiClient'

const api = new PaymentMethodsApi()
const tsApi = new PaymentMethodsApiTs(apiConfiguration)

export const usePaymentMethodsForCustomer = (
  params: ListPaymentMethodsRequest,
  options?: UseQueryOptions<ListPaymentMethods>
) => {
  return useQuery(
    ['customerPaymentMethods', { params }],
    () => tsApi.listPaymentMethods(params),
    options
  )
}

const fetchPaymentMethods = async ({ queryKey, pageParam: page = 1 }) => {
  const { params } = queryKey[1]

  const response = await api.listPaymentMethods({ page, ...params })

  return {
    data: response.data,
    page,
    nextPage: response.meta.last_page > page ? page + 1 : undefined,
    total: response.meta.total,
  }
}

export const useInfinitePaymentMethods = (params = {}, options = {}) =>
  useInfiniteQuery(['paymentMethods', { params }], fetchPaymentMethods, {
    getNextPageParam: (lastPage: any, pages) => {
      return lastPage.nextPage
    },
    ...options,
  })

export const useDeletePaymentMethod = () => {
  const queryClient = useQueryClient()

  return useMutation(
    async ([paymentMethodId]: [string]) => await api.deletePaymentMethod(paymentMethodId),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['customerPaymentMethods'])
      },
    }
  )
}
